
import './ListEntry.css'
import './Common.css'

export type ListEntryProps = {
    imageElement: JSX.Element,
    title: JSX.Element,
    subscript: JSX.Element,
    rightText: JSX.Element,
}

/* Common markup for all list elements, used in friends, catalog, tasks, etc
* Looks like this

* |   /    \  TEXT ONE                      |
* |  | Img |                      FINAL TEXT|
* |  \____/   TEXT TWO                      |
* 
* */
export function ListEntry(props: ListEntryProps) {
    return <div className="list-entry full-size">
        {props.imageElement}
        <div className="flex-row">
            <div className="list-entry-middle">
                <div className="flex-bottom"> {props.title} </div>
                <div className="flex-top"> {props.subscript} </div>
            </div>
            <div className="flex-y-center flex-x-right full-wide">
                {props.rightText}
            </div>
        </div>
    </div>
}

/* Looks like this

* |   /    \                          |
* |  | Img |  TEXT ONE     FINAL TEXT |
* |  \____/                           |
*
* */
export function ListEntrySingleLine(props: ListEntryProps) {
    return <div className="list-entry full-size">
        {props.imageElement}
        <div className="flex-row">
            <div className="flex-center"> {props.title} </div>
            <div className="flex-y-center flex-x-right full-wide">
                {props.rightText}
            </div>
        </div>
    </div>
}

export function ListEntrySquished(props: ListEntryProps) {
    return <div style={{height: "4.2rem", width: "100%", paddingTop: "0.1rem"}}>
        <ListEntry {...props}/>
    </div>
}

export function ListEntrySquishedSingleLine(props: ListEntryProps) {
    return <div style={{height: "4.3rem"}}>
        <ListEntrySingleLine {...props}/>
    </div>
}